export const refangIoc = (input: string): string => {
    return input
        .replace(/\[\.\]/g, '.')
        .replace(/<\.>/g, '.')
        .replace(/^hxxps?:\/\//i, '')
        .replace(/^https?:\/\//i, '')
        .trim()
}

const IPV4 = /(?:[0-9]{1,3}\.){3}[0-9]{1,3}(?:\/32)?/
const DOMAIN = /(?:\*\.)?(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}/

export const IOC_PATTERN = new RegExp(`^(?:${IPV4.source}|${DOMAIN.source})$`)
